export default "__VITE_ASSET__Bv0ETC82__"